
import { createSelector } from 'reselect';
import { IFacilityProfileState } from './types';

const selectFacilityProfileState = (state: { facilityProfile: IFacilityProfileState }) => state.facilityProfile;

export const selectFacilityProfile = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.data
);

export const selectFacilityProfileLoading = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.loading
);

export const selectFacilityProfileError = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.error
);

export const selectFacilityId = createSelector(
  selectFacilityProfile,
  (facilityProfile) => facilityProfile?.facility_id || null
);